import { render } from "./user-skills.vue?vue&type=template&id=66ce6404&ts=true"
import script from "./user-skills.vue?vue&type=script&lang=ts"
export * from "./user-skills.vue?vue&type=script&lang=ts"

import "./user-skills.vue?vue&type=style&index=0&id=66ce6404&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__